"use client";
import Image from "next/image";
import { GlareCard } from "../ui/glare-card";
import AnimationContainer from "../utils/animation-container";

const Thumbnail = () => {
  return (
    <div>
      <AnimationContainer delay={0.5}>
        <GlareCard 
            className="rounded-lg"
            glow={{enable: true, opacity: 0.02}}
            rotation={{stiffness: 10, damping: 10}}
        >
            <Image src={"/thumbnail/bloodstrike.avif"} width={1400} height={2024} alt=""/>
        </GlareCard>
      </AnimationContainer>
    </div>
  )
}

export default Thumbnail